// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"16":"2bdd36f4","187":"bafcd28d","802":"ae2064f5"}[chunkId] + ".css";
};